<script setup lang="ts">
import { onMounted, ref, watch } from 'vue';

import Chip from '@/components/Chip.vue';
import CustomButton from '@/components/CustomButton.vue';
import List from '@/components/List.vue';
import CreateFormTemplateDialog from '@/modules/rie/components/dialogs/CreateFormTemplateDialog.vue';
import { useFormTemplateStore } from '@/modules/rie/stores/formTemplate';
import { useAuthStore } from '@/stores/auth';
import type { DataTableHeader } from 'vuetify';

const formTemplateStore = useFormTemplateStore();
const authStore = useAuthStore();

const isInitializing = ref(true);

const isCreateDialogOpen = ref(false);

const headers: DataTableHeader[] = [
    { title: 'Naam', key: 'name', sortable: true },
    { title: 'Sector', key: 'sector', sortable: true },
    { title: 'Versie', key: 'version', sortable: false, value: (item) => item.version ?? '-' },
    { title: 'Status', key: 'isActive', sortable: true, value: (item) => getActiveObject(item.isActive) }
];

onMounted(async () => {
    try {
        await formTemplateStore.getAll();
    } finally {
        isInitializing.value = false;
    }
});

watch(
    () => authStore.currentOrganization,
    async (org) => {
        if (org) await formTemplateStore.getAll();
    }
);

function getActiveObject(isActive: boolean) {
    if (isActive) {
        return { color: 'success', label: 'Actief' };
    }

    return { color: 'red', label: 'Inactief' };
}
</script>

<template>
    <div>
        <CustomButton @click="isCreateDialogOpen = true" text="Nieuw sjabloon" />

        <List
            :is-initializing="isInitializing"
            :itemsPerPage="15"
            :headers
            :items="formTemplateStore.formTemplates"
            entity-name="Vragenlijst sjabloon"
            name-property="name"
        >
            <template #item.isActive="{ value, item }">
                <Chip :color="value.color" label>
                    {{ value.label }}
                </Chip>

                <Chip v-if="item.isDefault" label color="primary" class="ml-1"> Standaard </Chip>
            </template>
        </List>

        <CreateFormTemplateDialog v-model="isCreateDialogOpen" />
    </div>
</template>
